<template>
  <van-popup
    v-bind="$attrs"
    closeable
    position="bottom"
    :style="{ height: '100%' }"
  >
    <div class="popup-title">录入</div>
    <Content :bottom="76" :top="50">
      <van-form class="form" ref="form" @submit="submitValues">
        <Field
          name="gsCode"
          v-model="gsCode"
          label="气瓶出厂编号"
          :require="true"
          @on-blur="handleOnBlur"
        />
        <template v-if="showMoreForm">
          <Picker
            label="制造单位"
            :columns="selectValues.makeUnitList"
            :defaultVal="makeUnitName"
            :require="true"
            :disabled="isNew"
            @confirm-values="(values) => (makeUnit = values.dicVal)"
          />
          <Picker
            label="制造日期"
            pickerType="time"
            :defaultVal="makeDate"
            :require="true"
            :disabled="isNew"
            @confirm-values="(value) => (makeDate = value)"
          />
          <Picker
            label="检验日期"
            pickerType="time"
            :defaultVal="checkDate"
            :require="true"
            :disabled="isNew"
            @confirm-values="(value) => (checkDate = value)"
          />
          <Picker
            label="下次检验时间"
            pickerType="time"
            :defaultVal="nextCheckDate"
            :minDate="new Date()"
            :maxDate="new Date(2060, 0, 1)"
            :require="true"
            :disabled="isNew"
            @confirm-values="(value) => (nextCheckDate = value)"
          />
          <Picker
            label="充装介质"
            :columns="selectValues.gsMediumList"
            :defaultVal="gsGoodsName"
            :require="true"
            :disabled="isNew"
            @confirm-values="(values) => (gsMedium = values.dicVal)"
          />

          <Picker
            label="容积（L）"
            name="gsCapacity"
            :columns="gsCapacityList"
            :defaultVal="gsCapacity"
            :require="true"
            :disabled="isNew"
            @confirm-values="(values) => (gsCapacity = values.value + '')"
          />
          <Field
            name="gsPressure"
            v-model="gsPressure"
            :disabled="isNew"
            label="公称压力（MPa）"
          />
          <Picker
            label="气瓶种类"
            :columns="selectValues.gsTypeList"
            :defaultVal="gsTypeName"
            :require="true"
            :disabled="isNew"
            @confirm-values="(values) => (gsType = values.dicVal)"
          />
        </template>
      </van-form>
    </Content>
    <div class="btn-conatiner van-hairline--top">
      <van-button
        block
        type="primary"
        native-type="button"
        :loading="loading"
        :disabled="clickAble || isNew"
        loading-text="请稍后..."
        @click="handleSubmitClick"
      >
        保存
      </van-button>
    </div>
  </van-popup>
</template>

<script setup>
import { ref, computed, defineEmits, defineProps } from 'vue'
import { useStore } from 'vuex'
import { getDetailByCode, addExt } from '@/api/cylinderManageUserHome'

import { Toast, Notify } from 'vant'
const store = useStore()
const companyId = computed(() => store.state.roleInfo.companyId)
const emit = defineEmits(['add'])
const props = defineProps({
  selectValues: Object,
  sendUnit: String
})
// 钢瓶容量
const gsCapacityList = [
  { value: '11', dicValMean: '11L' },
  { value: '20', dicValMean: '20L' },
  { value: '25', dicValMean: '25L' },
  { value: '30', dicValMean: '30L' },
  { value: '35', dicValMean: '35L' },
  { value: '35.5', dicValMean: '35.5L' },
  { value: '40', dicValMean: '40L' },
  { value: '50', dicValMean: '50L' },
  { value: '72', dicValMean: '72L' },
  { value: '118', dicValMean: '118L' },
  { value: '175', dicValMean: '175L' },
  { value: '195', dicValMean: '195L' },
  { value: '210', dicValMean: '210L' },
  { value: '450', dicValMean: '450L' },
  { value: '495', dicValMean: '495L' }
]
// state
const gsCode = ref('')
const makeUnitName = ref('')
const mediumName = ref('')
const gsGoodsName = ref('')
const gsPressure = ref('')
const gsTypeName = ref('')

const loading = ref(false)
const clickAble = ref(false)

// 验证钢瓶
const isNew = ref(true)
const handleOnBlur = async () => {
  if (gsCode.value) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    })
    const res = await getDetailByCode(props.sendUnit, gsCode.value)
    const list = [
      makeUnit,
      gsMedium,
      makeDate,
      checkDate,
      nextCheckDate,
      gsType,
      gsCapacity,
      makeUnitName,
      gsGoodsName,
      gsPressure,
      gsTypeName,
      mediumName
    ]
    if (res.status === 401) {
      isNew.value = false
      list.forEach((item, index) => {
        item.value = ''
      })
    } else {
      const list2 = [
        'makeUnit',
        'gsMedium',
        'makeDate',
        'checkDate',
        'nextCheckDate',
        'gsType',
        'gsCapacity',
        'makeUnitName',
        'gsGoodsName',
        'gsPressure',
        'gsTypeName',
        'mediumName'
      ]
      list.forEach((item, index) => {
        item.value = res.data[list2[index]] + ''
      })
      isNew.value = true
      emit('add', res.data)
    }
    Toast.clear()
  }
}
// 清空表单
// 显示更多表单
const showMoreForm = computed(() => {
  return props.sendUnit && gsCode.value
})

const form = ref(null)
const handleSubmitClick = () => {
  form.value.submit()
}
const makeUnit = ref('')
const gsMedium = ref('')
const makeDate = ref('')
const checkDate = ref('')
const nextCheckDate = ref('')
const gsType = ref('')
const gsCapacity = ref('')

const submitValues = (values) => {
  Object.keys(values)
    .filter((item) => !item)
    .forEach((item) => {
      Reflect.deleteProperty(values, item)
    })

  const params = {
    ...values,
    makeUnit: makeUnit.value,
    gsMedium: gsMedium.value,
    makeDate: makeDate.value,
    checkDate: checkDate.value,
    nextCheckDate: nextCheckDate.value,
    gsType: gsType.value,
    gsCapacity: gsCapacity.value,
    companyId: companyId.value,
    sendUnit: props.sendUnit
  }
  loading.value = true
  addExt(params)
    .then(() => {
      Notify({ type: 'success', message: '操作成功' })
      emit('add', params)
    })
    .finally(() => {
      loading.value = false
    })
}
</script>

<style lang="scss" scoped>
.popup-title {
  background-color: #1989fa;
  padding: 15px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
}
.form {
  margin-bottom: 16px;
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
